/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GssOccasionPersonTeaser } from './gssOccasionPersonTeaser';

/**
 * People who registered for a GSS slot and are open to connect.

``attendance_resolved`` is always true. Membership is registration
(non-cancelled booking), not ``attended_minutes``. Kept so existing
clients do not treat an omitted field as waiting.
 */
export interface GssOccasionPeopleResponse {
  attendanceResolved?: boolean;
  eligibleCount: number;
  people: GssOccasionPersonTeaser[];
  viewerOpenToConnect: boolean;
}
